import cx from 'classnames';
import Axis from "./Axis.js";
import Orientation from "../constants/orientation.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const rightTickLabelProps = {
  dx: '0.25em',
  dy: '0.25em',
  fill: '#222',
  fontFamily: 'Arial',
  fontSize: 10,
  textAnchor: 'start'
};
export default function AxisRight(_ref) {
  let {
    axisClassName,
    labelOffset = 36,
    tickLength = 8,
    tickLabelProps,
    ...restProps
  } = _ref;
  const tickLabelPropsFinal = typeof tickLabelProps === 'function' ? tickLabelProps : {
    ...rightTickLabelProps,
    ...tickLabelProps
  };
  return /*#__PURE__*/_jsx(Axis, {
    axisClassName: cx('visx-axis-right', axisClassName),
    labelOffset: labelOffset,
    orientation: Orientation.right,
    tickLabelProps: tickLabelPropsFinal,
    tickLength: tickLength,
    ...restProps
  });
}